import React, { useState } from 'react';

interface SLIMetric {
  agent_name?: string;
  is_success: boolean;
  is_neutral: boolean;
  [key: string]: any;
}

interface SLIAnalyzerProps {
  onClose: () => void;
  sli_metrics: SLIMetric[];
}

const getRowColor = (metric: SLIMetric) => {
  if (metric.is_success) return '#d4edda'; // green
  if (metric.is_neutral) return '#fff3cd'; // yellow
  return '#f8d7da'; // red
};

const SLIAnalyzer: React.FC<SLIAnalyzerProps> = ({ onClose, sli_metrics }) => {
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const selectedMetric = sli_metrics[selectedIdx];

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" style={{ minWidth: 600, maxWidth: 900 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>SLI Metrics</h2>
          <button onClick={onClose} className="close-btn" aria-label="Close">✖️</button>
        </div>
        <div className="modal-legend" style={{ display: 'flex', gap: 24, alignItems: 'center', margin: '16px 0 0 0' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 16, height: 16, background: '#d4edda', borderRadius: 3, border: '1px solid #b2dfb2', display: 'inline-block' }} />
            Green = Success
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 16, height: 16, background: '#fff3cd', borderRadius: 3, border: '1px solid #ffe49c', display: 'inline-block' }} />
            Yellow = Neutral
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 16, height: 16, background: '#f8d7da', borderRadius: 3, border: '1px solid #f5b7b7', display: 'inline-block' }} />
            Red = Failure
          </span>
        </div>
        <div className="modal-body" style={{ marginTop: '1rem' }}>
          <div style={{ display: 'flex', height: 400, border: '1px solid #ccc', borderRadius: 8 }}>
            {/* Master list */}
            <div style={{ width: 220, borderRight: '1px solid #eee', overflowY: 'auto' }}>
              {sli_metrics.map((metric, idx) => (
                <div
                  key={idx}
                  onClick={() => setSelectedIdx(idx)}
                  style={{
                    padding: '12px 16px',
                    margin: '6px',
                    cursor: 'pointer',
                    background: getRowColor(metric),
                    fontWeight: idx === selectedIdx ? 'bold' : 'normal',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                >
                  {metric.agent_name || (selectedMetric.agent_id ? `Agent ${metric.agent_id}` : `Metric ${idx + 1} from Unknown Agent`)}
                </div>
              ))}
            </div>
            {/* Detail view */}
            <div style={{ flex: 1, padding: 24, height: '100%', overflowY: 'auto' }}>
              {selectedMetric ? (
                <div>
                  <h3>{selectedMetric.agent_name || (selectedMetric.agent_id ? `Agent ${selectedMetric.agent_id}` : 'Unknown Agent')}</h3>
                  <table>
                    <tbody>
                    {Object.entries(selectedMetric).map(([key, value]) => (
                      <tr key={key}>
                        <td style={{ fontWeight: 600, paddingRight: 12 }}>{key}</td>
                        <td>{typeof value === 'boolean' ? value.toString() : String(value)}</td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>Select a metric to view details.</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .modal-content {
          background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); padding: 1.5rem; position: relative;
        }
        .modal-header { display: flex; justify-content: space-between; align-items: center; }
        .close-btn { background: none; border: none; font-size: 1.2rem; cursor: pointer; }
      `}</style>
    </div>
  );
};

export default SLIAnalyzer;
